// extracted by mini-css-extract-plugin
export default {"groupInfoContainer":"groupInfo_groupInfoContainer__npSda","groupName":"groupInfo_groupName__XiHB5","inputField":"groupInfo_inputField__BVg8A"};